export default {
  heading: 'Barlow Condensed, sans-serif',
  subheading: 'Blowhole, sans-serif',
  body: 'Open Sans, sans-serif',
  body2: 'Comfortaa, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Billy, sans-serif',
  googleFonts: [
    'Playfair Display:400,500,600,700',
    'Cabin Sketch',
    'Noto Sans Display:100,200,300,400,500,600,700,800,900',
    'Open Sans:100,200,300,400,500,600,700,800,900',
    'Comfortaa',
    'Finger Paint',
    'Barlow Condensed:100,200,300,400,500,600,700,800,900'
  ],
  customFamilies: ['Billy', 'Blowhole', 'Supersonic Rocketship'],
  customUrls: [
    'https://www.gonation.biz/fonts/billy/billy.css',
    'https://www.gonation.biz/fonts/blowhole/blowhole.css',
    'https://www.gonation.biz/fonts/supersonic-rocketship/supersonic-rocketship.css'
  ]
}
